export interface ParsedOptimizationFailure {
  summary: string;
  solverStatus?: string;
  suspectedConstraints: string[];
  feasibleRelaxations: string[];
  raw: string;
}

const cleanToken = (value: string) =>
  value
    .replace(/^[-–•\s]+/, '')
    .replace(/[\s,;:.]+$/, '')
    .trim();

const splitSimpleList = (value: string): string[] =>
  value
    .split(/[;,]\s*/)
    .map(cleanToken)
    .filter(Boolean);

export function parseOptimizationFailure(rawMessage?: string): ParsedOptimizationFailure | null {
  if (!rawMessage || !rawMessage.trim()) return null;

  const raw = rawMessage.trim();
  const normalized = raw.replace(/\s+/g, ' ').trim();

  const solverStatusMatch = normalized.match(/\b(INFEASIBLE|UNBOUNDED|TIME_LIMIT|FAILED|UNKNOWN)\b/i);
  const solverStatus = solverStatusMatch?.[1]?.toUpperCase();

  const suspectedBlockMatch = normalized.match(/Suspected constraints:\s*(.*?)(?:Feasible when relaxing:|$)/i);
  const suspectedBlock = suspectedBlockMatch?.[1]?.trim() || '';

  const violationRegex = /([A-Za-z ]*constraint violated\s*\([^)]*\)(?:\s*\([^)]*\))*)/gi;
  const suspectedConstraints: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = violationRegex.exec(suspectedBlock)) !== null) {
    const value = cleanToken(match[1]);
    if (value) suspectedConstraints.push(value);
  }

  const suspectedRemainder = suspectedBlock
    ? cleanToken(suspectedBlock.replace(violationRegex, ' ').replace(/\s+/g, ' '))
    : '';

  if (suspectedRemainder) {
    splitSimpleList(suspectedRemainder).forEach((item) => {
      if (!suspectedConstraints.includes(item)) suspectedConstraints.push(item);
    });
  }

  const relaxMatch = normalized.match(/Feasible when relaxing:\s*(.*)$/i);
  const feasibleRelaxations = relaxMatch?.[1] ? splitSimpleList(relaxMatch[1]) : [];

  return {
    summary: normalized,
    solverStatus,
    suspectedConstraints,
    feasibleRelaxations,
    raw,
  };
}
